namespace Ir.Components.Workbook.ToolBar.SelectCompanyToolBar {
    interface ISelectCompanyToolBarViewModel {
        buttonOptions: any;
        callback: Function;
        onCompanyClick: (id: number, name: string) => void;
    }

    export function getViewModel(this: ISelectCompanyToolBarViewModel, params: any) {

        let showPopover;
        this.callback = function (obj) {
            showPopover = obj.show;
        }

        this.buttonOptions = {
            icon: 'spindown',
            stylingMode: 'text',
            title: 'Change Company',
            elementAttr: {
                class: "drawer-icon changeCompanyIcon"
            },
            onClick(e) {
                showPopover(e.element);
            },
            visible: ko.computed(function () { return workbook.workbookConfig.appBar.multiTenant; })
        }

        this.onCompanyClick = function (this: ISelectCompanyToolBarViewModel, id: number, name: string) {
            let url = `${urlConfigs.tabs}edit/${workbook.workbookConfig.workbookId()}?companyId=${id}&reloadManually=True`;
            let shared = false;

            let emptyWorkbook = workbook.workbookConfig.workbookId() < 0 ? workbook.workbookConfig.tabs().length === 0 : false;
            if (loggedUser.permissions.workbooks()) {
                shared = false;
            }

            if (!shared && !emptyWorkbook) {
                if (workbook.workbookConfig.hasPendingChanges && workbook.workbookConfig.generalSettings.editing()) {
                    let customDialog = DevExpress.ui.dialog.custom({
                        showTitle: false,
                        messageHtml: "All your changes will be lost. Make sure you save before changing Companies. Do you want to proceed?",
                        buttons: [
                            { text: "Yes", onClick: function () { return true } },
                            { text: "No", onClick: function () { return false } }
                        ]
                    });
                    customDialog.show().done(function (dialogResult) {
                        if (dialogResult) {
                            document.location.href = url;
                        }
                    });
                }
                else {
                    document.location.href = url;
                }
            } else {
                document.location.href = url;
            }

        }.bind(this);
    }
}